<template>
  <v-app>
    <slot />
    <v-overlay :value="errors.length" z-index="6">
      <v-card light>
        <v-card-title class="headline">
          <span class="title">
            Ooops...something went wrong. [{{ errors.length }} Errors]
          </span>
        </v-card-title>
        <v-card-text>
          <v-list-item v-for="error in errors" :key="error.vm.uuid">
            <v-list-item-content>
              <v-list-item-title>
                {{ error.info }}
              </v-list-item-title>
              <v-list-item-subtitle>
                <pre>{{ error.err }}</pre>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text color="error" @click="close">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-overlay>
  </v-app>
</template>

<script>
export default {
  name: 'error-boundary',
  data() {
    return {
      errors: []
    };
  },
  errorCaptured(err, vm, info) {
    if (err.message.match('status code 401')) {
      return false;
    }

    this.errors.push({ err, vm, info });

    return false;
  },
  methods: {
    close() {
      this.errors = [];
    }
  }
};
</script>
